import React from "react";
import "./ForInvestorsPage.scss";
import { backgroundArtArray } from "../../assets/assetReference";
import {
  bannerContent,
  servicesForDevelopers,
  servicesForInvestor,
} from "../../data/content/content";
import RedLineText from "../../components/RedLineText/RedLineText";
import ServiceBox from "../../components/ServiceBox/ServiceBox";
import SlideUpAnimation from "../../components/SlideUpAnimation/SlideUpAnimation";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ImgWhiteTemplate from "templates/ImgWhiteTemplate/ImgWhiteTemplate";
import GrayBanner from "components/GrayBanner/GrayBanner";

export default function ForInvestorsPage() {
  return (
    <>
      <Helmet>
        <title>For Investors | WeBridge</title>
        <meta name="description" content={bannerContent.forInvestor} />
        <meta
          name="keywords"
          content={`WeBridge, wind energy bridge, offshore wind energy, offshore wind developers, ${servicesForInvestor.map(
            (i) => " " + i.title
          )}`}
        />
      </Helmet>
      <div
        className={
          "for-developers-page-container for-suppliers-developers-page-container"
        }
      >
        <ImgWhiteTemplate
          backgroundImg={{
            src: backgroundArtArray.investors,
            alt: "a photo of two people analysing using graphs",
            type: "img",
          }}
          h1="For Investors"
          description={
            <span>
              Explore our{" "}
              <span className="text-main">services for investors</span> designed
              to enhance your investment strategies and maximize returns in the
              offshore wind sector.
            </span>
          }
        />
        <OtherContent />
      </div>
    </>
  );
}

function OtherContent() {
  return (
    <>
      <GrayBanner
        tag="WEBRIDGE"
        title={<p>What We Offer</p>}
        button={{ color: "main", text: "CONTACT US" }}
        content={
          <>
            <p>
              WeBridge offers a comprehensive range of services to debt and
              equity investors in the offshore wind industry, designed to
              support their investing and lending decisions, risk assessment,
              and due diligence processes.
            </p>
          </>
        }
      />
      <div className="other-content">
        <SlideUpAnimation triggerOnce={false}>
          <div className="subheading-container">
            <h2 className="subheading">Our Services</h2>
            <RedLineText
              TextContent={
                <p>
                  Our industry expertise and tailored solutions empower
                  investors to navigate the complexities of the industry,
                  contribute to well-informed financial practices, and support
                  projects that align with their financial and risk management
                  goals.
                </p>
              }
            />
          </div>
        </SlideUpAnimation>
        <div className="service-list">
          {servicesForInvestor.map((i, index) => {
            return (
              <ServiceBox
                img={{ src: i.icon, alt: `icon for ${i.title}` }}
                item={i}
              />
            );
          })}
        </div>
      </div>
      <NavLink to="/" className="back-to-home">
        Back to Home
      </NavLink>
    </>
  );
}
